import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Physio from "@/components/site/Physio";
import Packages from "@/components/site/Packages";
import Reviews from "@/components/site/Reviews";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#F5F0E8] min-h-screen" data-testid="physiora-app">
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <About />
        <Physio />
        <Packages />
        <Reviews />
        <FAQ />
      </main>
      <Footer />
      <Toaster position="top-center" toastOptions={{ style: { background: "#111111", color: "#F5F0E8", border: "1px solid #8DA37F" } }} />
    </div>
  );
}
